/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_HelpInputs */



/**
* | output |
* | --- |
* | "Select the user's role in the system" |
*
* @param {Team_Manager_Role_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_help = /** @type {((inputs?: Team_Manager_Role_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez le rôle de l’utilisateur dans le système")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Rolle des Benutzers im System aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il ruolo dell'utente nel sistema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите роль пользователя в системе.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el rol del usuario en el sistema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择用户在系统中的角色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("システム内でのユーザーの役割を選択する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिस्टम में उपयोगकर्ता की भूमिका का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a função do usuário no sistema.")
	return /** @type {LocalizedString} */ ("Select the user's role in the system")
});